// Work can't be logged ahead of today, only absence (vacation, sick leave,
// doctor, public holiday…) can. The server enforces it (backend futureWork.js)
// on the org's day; this mirrors it so the UI can steer before a save is
// refused. Dates are ISO YYYY-MM-DD, so string order is date order.

import { isoDate } from './time.js';

export const FUTURE_WORK_MESSAGE =
  "Work can't be logged in the future. Only absence (vacation, sick leave, doctor, public holiday…) can be logged ahead.";

// "Today" in the org's zone (bootstrap's orgTimezone), so a browser behind or
// ahead of the org draws the line where the server does. Without a usable
// zone it falls back to the browser's own date.
export function orgToday(timezone, now = new Date()) {
  if (timezone) {
    try {
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-US', {
          timeZone: timezone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
          .formatToParts(now)
          .map((part) => [part.type, part.value]),
      );
      return `${parts.year}-${parts.month}-${parts.day}`;
    } catch {
      // An unknown zone: the browser's date below.
    }
  }
  return isoDate(now);
}

export function isFutureWork(project, workDate, today) {
  return Boolean(project) && !project.absence && workDate > today;
}

// The same, on the org's day at `now` rather than a render's snapshot, so a
// dialog left open across the org's midnight saves on the new day.
export function isFutureWorkNow(project, workDate, timezone, now = new Date()) {
  return isFutureWork(project, workDate, orgToday(timezone, now));
}

// What the project picker offers for a day: everything up to today, only
// absence projects after it — plus keepId (the picked project), so the
// picker still shows what the entry is on.
export function projectsForDate(projects, workDate, today, keepId) {
  if (!workDate || workDate <= today) return projects;
  return projects.filter((project) => project.absence || project.id === keepId);
}
